// Tiny fetch helper that replaces the Supabase JS client. Backend now exposes
// the data behind explicit /api/... endpoints; we just call them.

const BASE = process.env.REACT_APP_API_URL || '';

function authHeaders() {
  if (typeof window === 'undefined' || !window.sessionStorage) return {};
  const token = window.sessionStorage.getItem('adminToken')
    || window.sessionStorage.getItem('memberToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function apiFetch(path, opts = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...authHeaders(),
    ...(opts.headers || {}),
  };
  const init = { ...opts, headers };
  if (init.body && typeof init.body !== 'string') {
    init.body = JSON.stringify(init.body);
  }
  const res = await fetch(`${BASE}${path}`, init);
  if (!res.ok) {
    let detail;
    try { detail = await res.json(); } catch { detail = await res.text(); }
    const err = new Error(typeof detail === 'string' ? detail : (detail.error || res.statusText));
    err.status = res.status;
    err.detail = detail;
    throw err;
  }
  return res.json();
}
